import { BulkPostDelete } from 'src/pages/scheduledPost/Grid/BulkPostDelete';
import { Card, Table, TableContainer } from '@mui/material';
import { useEffect, useState } from 'react';
import Scrollbar from 'src/components/scrollbar/Scrollbar';
import DynamicHeightComponent from 'src/utils/dynamicSize.component';
import NoPostFound from '../../publishedPosts/noPost.component';
import FailedPostGridBody from './FailedPostGridBody.component';
import FailedPostGridHead from './FailedPostGridHead.component';
import FailedPostGridPagination from './FailedPostGridPagination.component';

const FailedPostGrid = ({ failedPostList, orderBy, order,isOrgEvent, handleReCallFailedPost,isShowOfferBanner=false  }) => {
  const [page, setPage] = useState(0);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [height, setHeight] = useState(window.innerHeight - 200);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    let orderStr = isAsc ? 'desc' : 'asc';
    handleReCallFailedPost(property, orderStr);
  };

  useEffect(() => { setPage((current) => Math.min(current, Math.max(0, Math.ceil((failedPostList?.length || 0) / rowsPerPage) - 1))); }, [failedPostList, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleRecallFailedPostWithSort = () => {
    handleReCallFailedPost(orderBy, order);
  };

  return (
    <BulkPostDelete rows={failedPostList} page={page} rowsPerPage={rowsPerPage} isOrgEvent={isOrgEvent} onDeleted={() => { setPage(0); handleRecallFailedPostWithSort(); }}>
      {failedPostList && failedPostList.length > 0 ? (
        <>
          <DynamicHeightComponent>
            <Scrollbar>
              <TableContainer
                sx={{
                   height: isShowOfferBanner ? 'calc(100vh - 418px)' : 'calc(100vh - 368px)',
                }}
              >
                <Table aria-label="collapsible table" stickyHeader>
                  <FailedPostGridHead
                    failedPostList={failedPostList}
                    order={order}
                    orderBy={orderBy}
                    handleRequestSort={handleRequestSort}
                  ></FailedPostGridHead>
                  <FailedPostGridBody
                    failedPostList={failedPostList}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    isOrgEvent={isOrgEvent}
                    handleReCallFailedPost={handleRecallFailedPostWithSort}
                  ></FailedPostGridBody>
                </Table>
              </TableContainer>
              <FailedPostGridPagination
                failedPostList={failedPostList}
                page={page}
                rowsPerPage={rowsPerPage}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
              ></FailedPostGridPagination>
            </Scrollbar>
          </DynamicHeightComponent>
        </>
      ) : (
        <Card
          style={{
            justifyContent: 'center',
            height: height,
            alignItems: 'center',
            minHeight: 'calc(100vh - 150px)',
            maxHeight: 'calc(100vh - 150px)',
          }}
        >
          <NoPostFound height={height} />
        </Card>
      )}
    </BulkPostDelete>
  );
};
export default FailedPostGrid;
